<template>
  <div class="f360-marcadores" v-if="hasMarcadores">
    <span v-for="marcador in marcadores" :key="marcador">
      <div class="f360-marcadores__item" @click="handleMarcadorClick(marcador)">
        {{ marcador }}
      </div>
    </span>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

const props = defineProps<{
  marcadores?: string[];
}>();

const hasMarcadores = computed(() => !!props.marcadores?.length);

const emit = defineEmits<{
  "marcador-click": [marcador: string];
}>();

const handleMarcadorClick = (marcador: string) => {
  emit("marcador-click", marcador);
};
</script>

<style scoped lang="scss">
.f360-marcadores {
  font-family: $fontFamily;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
  background-color: #fff;
  gap: 8px;

  &__item {
    margin: 0 !important;
    color: #1e8bff;
    width: fit-content;
    background-color: #f6f6f6;
    padding: 4px;
    border-radius: 4px;
    font-weight: 400;
    font-size: 14px;
    cursor: pointer;
  }

  &__item:hover {
    background-color: #e6f7ff;
  }
}
</style>
